module.exports = __webpack_public_path__ + "img/paperclip.7725462f.svg";